import { render } from "./StateMessage.vue?vue&type=template&id=203b96db&scoped=true&ts=true"
import script from "./StateMessage.vue?vue&type=script&lang=ts"
export * from "./StateMessage.vue?vue&type=script&lang=ts"

import "./StateMessage.vue?vue&type=style&index=0&id=203b96db&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203b96db"]])

export default __exports__